import * as yup from 'yup';

const periodValues = ['daily', 'weekly', 'monthly', 'once'];

export const validationForm = () => yup.object({
  msgName: yup.string().required("Обов'язково до заповнення"),
  msgText: yup.string().required("Обов'язково до заповнення"),
  period: yup.string().oneOf(periodValues, 'Неправильне значення').required("Обов'язково до заповнення")
});
